import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * Validator that checks if a datetime-local or date string value is in the past.
 * Returns `{ pastDate: true }` if the date is before the current moment.
 * Returns `null` if the control is empty or the date is today or in the future.
 */
export function pastDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || !String(value).trim()) {
      return null;
    }

    const strVal = String(value).trim();
    const dateOnlyMatch = strVal.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const now = new Date();

    if (dateOnlyMatch) {
      const endOfDay = new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3]),
        23,
        59,
        59,
        999,
      );
      return endOfDay < now ? { pastDate: true } : null;
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return null;
    }

    return date < now ? { pastDate: true } : null;
  };
}